export default __webpack_public_path__ + "static/media/death.709b57c9.png";